import { useInfiniteQuery } from "@tanstack/react-query";
import { claves, useClienteApi, type PaginaAuditoria } from "@/shared/api";

const paginas = {
  initialPageParam: null as string | null,
  getNextPageParam: (p: PaginaAuditoria) => p.siguiente,
};

export function useHistorial(usuarioId: string) {
  const api = useClienteApi();
  return useInfiniteQuery({
    queryKey: claves.historial(usuarioId),
    queryFn: ({ pageParam }) => api.historial(usuarioId, pageParam),
    ...paginas,
  });
}

/** `dia`: fecha de calendario de Chile (AAAA-MM-DD). */
export function useAuditoriaDelDia(dia: string) {
  const api = useClienteApi();
  return useInfiniteQuery({
    queryKey: claves.auditoriaDelDia(dia),
    queryFn: ({ pageParam }) => api.auditoria(dia, pageParam),
    ...paginas,
  });
}
